import { createSlice } from "@reduxjs/toolkit";
import { aboutMembersAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const aboutMembersSlice = createSlice({
  name: "aboutMembers",
  initialState: data,
  reducers: {
    aboutMembersSlice(state) {
      state.isLoading = false;
    },
    aboutMembersSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    aboutMembersSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    aboutMembersSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const aboutMembersHandler = () => async (dispatch: any) => {
  try {
    dispatch(aboutMembersAction.aboutMembersSlice());
    const response: any = await aboutMembersAPI();
    dispatch(aboutMembersAction.aboutMembersSliceSuccess(response));
  } catch (e: any) {
    dispatch(aboutMembersAction.aboutMembersSliceFailure(e?.response?.data?.message));
    dispatch(aboutMembersAction.aboutMembersSliceReset());
  }
};
export default aboutMembersSlice.reducer;
export const aboutMembersAction = aboutMembersSlice.actions;
